import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import {
	failureMessage,
	successMessage
} from '../Notifications/notificationsSlice';
import { primaryApi } from '../../utilities/apiEndpointUtility';

import i18n from '../../i18n';

import {
	createContact,
	createContactCompleted,
	createContactFailed,
	getContacts,
	getContactsCompleted,
	getContactsFailed
} from './contactsSlice';

export const createContactEpic = (action$) =>
	action$.pipe(
		ofType(createContact.type),
		mergeMap(async (action) => {
			const payload = action.payload;
			const formData = new FormData();

			if (payload.avatar) {
				formData.append('file', payload.avatar);
			}

			delete action.payload.avatar;

			for (const [key, value] of Object.entries(action.payload)) {
				formData.append(key, value);
			}

			const response = await axios.post(
				`${primaryApi()}/api/v1/contacts`,
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			);

			if (response.status !== 200) {
				throw response.data;
			}

			return response.data;
		}),
		switchMap((res) => [
			createContactCompleted(res),
			successMessage(i18n.t('notifications:createContactSuccess'))
		]),
		catchError((error, source) =>
			merge(
				of(createContactFailed(error.message), failureMessage(error.message)),
				source
			)
		)
	);

export const getContactsEpic = (action$) =>
	action$.pipe(
		ofType(getContacts.type),
		mergeMap(async (action) => {
			try {
				const response = await axios.get(`${primaryApi()}/api/v1/contacts`);

				if (response.status !== 200) {
					throw response.data;
				}

				return response.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => [getContactsCompleted(res)]),
		catchError((error, source) =>
			merge(
				of(getContactsFailed(error.message), failureMessage(error.message)),
				source
			)
		)
	);

export default [createContactEpic, getContactsEpic];
